'use client';

import React from 'react';
import { EventSearch } from '../shared/EventSearch';
import { TimeFilter, TimeFilterOption } from '../shared/TimeFilter';
import { SeparatedEvents } from '../events/SeparatedEvents';
import { useEvents } from '@/lib/hooks/useEvents';

const HomeExplore = ({ firstName }: { firstName: string }) => {
	const [timeFilter, setTimeFilter] =
		React.useState<TimeFilterOption>('this-week');
	const { events, loading, error } = useEvents(true, timeFilter);
	const [isStandalone, setIsStandalone] = React.useState(false);

	React.useEffect(() => {
		setIsStandalone(window.matchMedia('(display-mode: standalone)').matches);
	}, []);

	return (
		<main className='w-screen h-full flex flex-col gap-6 px-4 mb-48'>
			{/* Welcome Header */}
			<section className='flex flex-col gap-4' id='explore-header'>
				{firstName ? (
					<h1 className='md:text-4xl text-xl text-start'>
						Welcome, {firstName}
					</h1>
				) : (
					<h1 className='md:text-4xl text-xl text-start'>Welcome</h1>
				)}
				<EventSearch />

				{/* Time Filter */}
				<TimeFilter
					selectedFilter={timeFilter}
					onFilterChange={setTimeFilter}
				/>
			</section>

			{/* Events List */}
			<section className='w-full'>
				<SeparatedEvents
					events={events}
					loading={loading}
					error={error}
					isStandalone={isStandalone}
				/>
			</section>
		</main>
	);
};

export default HomeExplore;
